export enum JobModeEnum {
  FULL_TIME = "FULL_TIME",
  PART_TIME = "PART_TIME",
  CONTRACT_BASE = "CONTRACT_BASE",
}
export const jobModeList = Object.values(JobModeEnum);

export enum JobStatusEnum {
  draft = "DRAFT",
  underReview = "UNDER_REVIEW",
  published = "PUBLISHED",
  rejected = "REJECTED",
  archived = "ARCHIVED",
}
export const jobStatusList = Object.values(JobStatusEnum);

export enum SalaryRateEnum {
  year = "YEAR",
  month = "MONTH",
  hourly = "HOURLY",
}
export const salaryRateList = Object.values(SalaryRateEnum);

export enum ApplyCriteriaEnum {
  onlyVerifiedFootballers = "verified",
  onlyWithTestimonials = "onlyTalentsWithTestimonials",
  profileCompletionAbove80 = "profileCompletionAbove80",
}
export const applyCriteriaList = Object.values(ApplyCriteriaEnum);

export enum IntroductoryVideoLengthEnum {
  LESS_THAN_ONE_MIN = "LESS_THAN_ONE_MIN",
  ONE_TO_THREE_MIN = "ONE_TO_THREE_MIN",
  THREE_TO_FIVE_MIN = "THREE_TO_FIVE_MIN",
  ABOVE_FIVE_MIN = "ABOVE_FIVE_MIN",
}
export const introductoryVideoLengthList = Object.values(IntroductoryVideoLengthEnum);

export enum ClubsEnum {
  alAhly = 5,
  zamalek = 6,
}
export const clubsList = [
  {
    label: "Al Ahly",
    value: 5,
  },
  {
    label: "Zamalek",
    value: 6,
  },
];

export enum GinoFitScoreEnum {
  strongFit = "STRONG_FIT",
  mediumFit = "MEDIUM_FIT",
  weakFit = "WEAK_FIT",
}
export const ginoFitScoreList = Object.values(GinoFitScoreEnum);

export enum ComplianceEnum {
  comply = "COMPLY",
  notComply = "NOT_COMPLY",
  partiallyComply = "PARTIALLY_COMPLY",
}
export const complianceList = Object.values(ComplianceEnum);

export enum HiringMission {
  TALENT_DISCOVERY = "TALENT_DISCOVERY",
  PROFESSIONAL_RECRUITMENT = "PROFESSIONAL_RECRUITMENT",
}

export enum Bucket {
  APPLIED = "APPLIED",
  SHORT_LISTED = "SHORT_LISTED",
  QUALIFIED = "QUALIFIED",
  DISREGARDED = "DISREGARDED",
}
export const bucketList = [Bucket.APPLIED, Bucket.SHORT_LISTED, Bucket.QUALIFIED, Bucket.DISREGARDED];
